import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const etTranslations: PluginDefaultTranslationsObject = {
  'plugin-multi-tenant': {
    'assign-tenant-button-label': 'Määra Tenant',
    'assign-tenant-modal-title': 'Määra "{{title}}"',
    'field-assignedTenant-label': 'Määratud üürnik',
    'nav-tenantSelector-label': 'Üürnik',
  },
}

export const et: PluginLanguage = {
  dateFNSKey: 'et',
  translations: etTranslations,
}
